import { ButtonBase } from ".";
import { ACTION_STATUS } from "..";

export class CopyButtonModel extends ButtonBase {
    label: string = 'Copy';
    action: string = ACTION_STATUS.copy;
    matIconName: string = 'file_copy';
    colorClass: string = 'color-secondary-500';
}